import { stripAnsi } from '@cli-utils/text.js'

/**
 * Vercel prints `Aliased: https://…` when a stable production alias is assigned; `Production:` and
 * stdout carry deployment-specific URLs instead.
 */
export function parseDeployedUrl(stdout: string, stderr: string): string | undefined {
  const plainErr = stripAnsi(stderr)
  const aliased = plainErr.match(/Aliased:\s+(https:\/\/\S+)/i)?.[1]
  if (aliased) return aliased

  const production = plainErr.match(/Production:\s+(https:\/\/\S+)/i)?.[1]
  if (production) return production

  const fromStdout = stripAnsi(stdout).match(/https:\/\/\S+/)?.[0]
  return fromStdout
}
